import m from "../../es2015/lang/ar";
window.am4lang_ar = m;


//////////////////
// WEBPACK FOOTER
// ./lang/ar.js
// module id = null
// module chunks = 